/**
 * <seo-meta-sync>
 *
 * Keeps the document <title> and <meta name="description"> in sync with the
 * current page during AJAX collection pagination/filtering. The theme's AJAX
 * loader only swaps the section's [data-ajax-container] regions and never the
 * document <head>, so this element is rendered inside such a container carrying
 * the freshly computed values as data attributes. When the AJAX swap re-inserts
 * it (or on initial load), connectedCallback mirrors those values into <head>.
 */
const SeoMetaSync = class extends HTMLElement {
  connectedCallback() {
    const title = this.getAttribute('data-title');
    const description = this.getAttribute('data-description');

    if (title) {
      document.title = title;
    }

    // Only sync a non-empty description: a blank value (e.g. a collection with
    // no migrated description) must not create or overwrite the meta tag.
    if (description) {
      let meta = document.head.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }
  }
};

window.customElements.define('seo-meta-sync', SeoMetaSync);
